export async function fetchCryptoPrices() {
  const URL =
    "https://api.coingecko.com/api/v3/simple/price?ids=bitcoin,ethereum,ripple,dogecoin,litecoin&vs_currencies=usd";
  try {
    const response = await fetch(URL);
    if (!response.ok) throw new Error("Network error");
    const data = await response.json();
    return data;
  } catch (error) {
    return {
      bitcoin: { usd: 20000 },
      ethereum: { usd: 1500 },
      ripple: { usd: 0.5 },
      dogecoin: { usd: 0.1 },
      litecoin: { usd: 100 },
    };
  }
}

export async function getRandomHash() {
  const cryptoPrices = await fetchCryptoPrices();
  const coinPriceString = Object.keys(cryptoPrices)
    .sort()
    .map((coin) => `${coin}:${cryptoPrices[coin].usd}`)
    .join("-");
  const seed = `${coinPriceString}-${Date.now()}-${Math.random()}`;
  let hash = 5381;
  for (let i = 0; i < seed.length; i++) {
    hash = (hash * 33) ^ seed.charCodeAt(i);
  }
  return (hash >>> 0).toString(16);
}

export async function getSeededRandomNumber(max) {
  const hash = await getRandomHash();
  const hashNum = parseInt(hash, 16);
  return hashNum % max;
}

export async function getSeededRandomDecimal(min, max, decimals = 4) {
  const hash = await getRandomHash();
  const hashNum = parseInt(hash, 16);
  const fraction = hashNum / 4294967295;
  const value = min + fraction * (max - min);
  const factor = Math.pow(10, decimals);
  return Math.floor(value * factor) / factor;
}
